import { useDialogComposable } from "~/components/Base/Dialog/useDialogs.composable";

export const useDialog = useDialogComposable;
